import { get, post, put, destroy } from '@/api/request';

function fetchSchedules(params = {}) {
  return get('/schedules', params);
}

function fetchSchedule({ userId }) {
  return get(`/users/${userId}/schedules`);
}

function createSchedule(data) {
  return post('/schedules', data);
}

function updateSchedule({ id, data }) {
  return put(`/schedules/${id}`, data);
}

function deleteSchedule(id) {
  return destroy(`/schedules/${id}`);
}

export default {
  fetchSchedules,
  fetchSchedule,
  createSchedule,
  updateSchedule,
  deleteSchedule,
};



// WEBPACK FOOTER //
// ./src/store/modules/schedule/api.js